import ExtensionAPI from 'echarts/types/src/core/ExtensionAPI';
import GlobalModel from 'echarts/types/src/model/Global';
import GraphSeriesModel, { GraphNodeItemOption } from 'echarts/types/src/chart/graph/GraphSeries';

export function absoluteLayout(ecModel: GlobalModel, api: ExtensionAPI) {
  ecModel.eachSeriesByType('graph', function (graphSeries: GraphSeriesModel) {
    const coordSys = graphSeries.coordinateSystem;
    const layout = graphSeries.get('layout') as unknown;
    if (!coordSys || coordSys.type !== 'view') {
      return;
    }
    if (layout === 'absolute') {
      const graph = graphSeries.getGraph();
      const nodeData = graph.data;
      // 获取初始位置信息
      let nodes = nodeData.mapArray('value', function (value: number, idx) {
        const dvPosition = nodeData.getItemModel<GraphNodeItemOption>(idx).get('dvPosition') as
          | [number, number]
          | null;

        return {
          idx,
          x: dvPosition ? dvPosition[0] : null,
          y: dvPosition ? dvPosition[1] : null,
          radius: (nodeData.getItemModel<GraphNodeItemOption>(idx).get('symbolSize') as number) / 2
        };
      });
      // 删除空值
      nodes = nodes.filter(node => node.x && node.y);
      // 应用布局

      nodes.forEach(node => {
        nodeData.setItemLayout(node.idx, [node.x, node.y]);
      });
    }
  });
}
